import cache from "memory-cache";

const neighbourhoods = {
    '17000': 'Holešovice',
    '18600': 'Karlín'
}

export const neighbourhoodsByZip = (zip) => {
    if (!zip) return null;
    zip = zip.toString().split(' ').join('');
    return neighbourhoods[zip] || null;
};

export const getJobFilters = (jobs = []) => {
    const filters = {
        departments: [],
        locations: []
    };

    jobs.forEach(({department, location}) => {
        if (department && !filters.departments.includes(department)) {
            filters.departments.push(department);
        }
        if (location && !filters.locations.includes(location)) {
            filters.locations.push(location);
        }
    });

    return filters;
}

const jobApiBase = 'https://nextmove.workable.com/spi/v3/jobs';

const jobApiConfig = {
    method: 'GET',
    headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer RblwvuhmOaoQPLXq57YEmoLns-3NdyCLzxDaxQEAZVQ`
    }
};

const formatJobItemData = (item) => {
    return {
        url: item.application_url,
        department: item.department,
        description: item.description,
        benefits: item.benefits,
        location: neighbourhoodsByZip(item.location.zip_code),
        requirements: item.requirements,
        title: item.title
    };
}

const getJobPositionsFromApi = async () => {
    const jobs = await fetch(jobApiBase, jobApiConfig)
        .then((res) => res.json())
        .then((res) => res.jobs.filter(({state}) => state === 'published'))
        .catch((error) => {
            console.error('=== JOBS ERROR ===')
            console.error(error);
            return [];
        });

    let jobsWithDetails = [];

    if (jobs && Array.isArray(jobs)) {
        jobsWithDetails = await Promise.all(jobs.map(async ({shortcode}) => {
            return await fetch(`${jobApiBase}/${shortcode}`, jobApiConfig)
                .then((res) => res.json())
                .then((item) => {
                    if (item.error || !item.title) {
                        return null;
                    }

                    return formatJobItemData(item);
                });
        }));

        jobsWithDetails = jobsWithDetails.filter(Boolean)
    }

    return jobsWithDetails;
};

export const getCachedJobPositions = async () => {
    const cachedResponse = cache.get('jobs');

    if (cachedResponse && Array.isArray(cachedResponse) && cachedResponse.length > 0) {
        return cachedResponse;
    }

    const hours = 0.5;
    const data = await getJobPositionsFromApi();
    cache.put('jobs', data, hours * 1000 * 60 * 60);
    return data;
}